import React from 'react';
import {
  CreateBase,
  SimpleForm,
  TextInput,
  useNotify,
  useRedirect,
  useCreate,
  required,
  DateInput,
  SimpleFormIterator,
  ArrayInput,
} from "react-admin";
import { useWatch } from "react-hook-form";
import Box from "@mui/material/Box";

// 单独封装联系方式 ArrayInput，限制最多 3 个
const ContactsArray = () => {
  const contacts = useWatch({ name: "contacts" }) || [];
  const maxContacts = 3;

  return (
    <ArrayInput source="contacts" label="contacts">
      <SimpleFormIterator
        fullWidth
        disableAdd={contacts.length >= maxContacts}
        disableRemove={false}
        sx={{
          width: '100%',
          '& .RaSimpleFormIterator-line': {
            marginTop: '20px',
            paddingBottom: '20px',
          },
          '& .RaSimpleFormIterator-action': {
            marginTop: '8px !important',
          }, backgroundColor: '#f7f7f7', padding: '16px', borderRadius: '8px',
          '& .MuiFormControl-root': { height: '50px' }
        }}
      >
        <Box display="flex" gap={2} width="100%">
          <Box flex="1 1 30%">
            <TextInput
              source="name"
              label="Name"
              fullWidth
              validate={[required()]}
            />
          </Box>
          <Box flex="1 1 30%">
            <TextInput
              source="phone"
              label="Phone"
              fullWidth
              validate={[required()]}
            />
          </Box>
          <Box flex="1 1 30%">
            <TextInput
              source="email"
              label="Email"
              fullWidth
              validate={[required()]}
            />
          </Box>
        </Box>
      </SimpleFormIterator>
    </ArrayInput>
  );
};

// 工厂下的证书
const CertificatesArray = () => (
  <ArrayInput source="certificates" label="Certificates">
    <SimpleFormIterator sx={{
      width: '100%',
      '& .RaSimpleFormIterator-line': {
        marginTop: '20px',
        paddingBottom: '20px',
      },
      '& .RaSimpleFormIterator-action': {
        marginTop: '8px !important',
      }, backgroundColor: '#f7f7f7', padding: '16px', borderRadius: '8px',
      '& .MuiFormControl-root': { height: '50px' }
    }}>
      <Box display="flex" gap={2} width="100%">
        <Box flex="1 1 40%">
          <TextInput source="name" label="Certificate Name" fullWidth validate={[required()]} />
        </Box>
        <Box flex="1 1 30%">
          <DateInput source="issueDate" label="Issue Date" fullWidth />
        </Box>
        <Box flex="1 1 30%">
          <DateInput source="expiryDate" label="Expiry Date" fullWidth />
        </Box>
      </Box>
    </SimpleFormIterator>
  </ArrayInput>
);

// 工厂信息
const FactoriesArray = () => (
  <ArrayInput source="factories" label="Factories">
    <SimpleFormIterator
      sx={{
        width: '100%',
        '& .RaSimpleFormIterator-line': {
          marginTop: '20px',
          paddingBottom: '20px',
        },
        backgroundColor: '#e8f4fd',
        padding: '16px',
        borderRadius: '8px',

        '& .MuiTextField-root': { height: '50px' }
        ,
        '& .MuiFormControl-root span': { marginTop: 2 },
        '& .RaSimpleFormIterator-form': {
          width: '90%'
        }
      }}
    >
      <Box display="flex" gap={2} width="100%">
        <Box flex="1 1 40%">
          <TextInput source="name" label="Factory Name" fullWidth validate={[required()]} />
        </Box>
        <Box flex="1 1 60%">
          <TextInput source="address" label="Address" fullWidth />
        </Box>
      </Box>

      {/* 工厂下的证书 */}
      <CertificatesArray />
    </SimpleFormIterator>
  </ArrayInput>
);

const SupplierCreate: React.FC = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [create] = useCreate();

  const handleSave = async (data: any) => {
    const newData = {
      ...data,
      emailStatus: "NotSent", // 新增隐藏状态字段，默认0
    };
    create(
      'supplier',
      { data: newData },
      {
        onSuccess: () => {
          notify('Save Successfully', { type: 'info' });
          redirect('list', 'supplier');
        },
        onError: (error: any) => {
          if (error?.body?.status === 409 || error?.status === 409) {
            notify('Name already exists', { type: 'error' });
          } else {
            notify('Save Failed', { type: 'error' });
          }
        },
      }
    );
  };

  return (
    <CreateBase resource="supplier">
      <SimpleForm
        sx={{ backgroundColor: '#ffffff', padding: '36px' }}
        onSubmit={handleSave}
      >
        <Box display="flex" flexWrap="wrap" gap={2} width="100%">
          <Box flex="1 1 48%">
            <TextInput
              source="name"
              label="Name"
              fullWidth
              validate={[required()]}
            />
          </Box>


          <Box flex="1 1 100%">
            <ContactsArray />
          </Box>

          <Box flex="1 1 48%">
            <TextInput source="address" label="Address" fullWidth />
          </Box>
          {/* <Box flex="1 1 48%">
            <DateInput
              source="expiredDate"
              label="Certificate Expiry Date"
              fullWidth
            />
          </Box> */}
          {/* 工厂信息（含证书） */}
          <Box flex="1 1 100%">
            <FactoriesArray />
          </Box>
        </Box>
      </SimpleForm>
    </CreateBase>
  );
};

export default SupplierCreate;
